import { Box, Container, Grid, Stack, Typography } from '@mui/joy';
import {
    SealCheck,
    PhoneCall,
    Prohibit,
    Sparkle,
} from '@phosphor-icons/react';
import { FadeIn } from './FadeIn';

const ADVANTAGES = [
    { icon: PhoneCall, title: 'Звонки на наших серверах', text: 'Разговаривайте спокойно, ведь вас никто не прослушивает.' },
    { icon: Prohibit, title: 'Никакой рекламы', text: 'В ленте только те, на кого вы подписаны: ни рекомендаций, ни баннеров.' },
    { icon: SealCheck, title: 'Доступен без ограничений', text: 'Без блокировок и обходных решений.' },
    { icon: Sparkle, title: 'Ничего лишнего', text: 'Один понятный сервис для общения и записей.' },
];

export function WhyAquariumSection() {
    return (
        <Container maxWidth="lg">
            <Box sx={{ my: { md: 12, xs: 6 } }}>
                <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center">
                    <Grid xs={12} md={5}>
                        <FadeIn>
                            <Typography
                                level="h2"
                                sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: 2 }}
                            >
                                Чистая среда{' '}
                                <Box component="br" sx={{ display: { xs: 'none', md: 'block' } }} />
                                для общения
                            </Typography>
                            <Typography level="body-lg" sx={{ color: 'text.secondary' }}>
                                Мы выбрали другой путь: спокойный мессенджер и микроблог только с самым необходимым.
                            </Typography>
                        </FadeIn>
                    </Grid>
                    <Grid xs={12} md={7}>
                        <Box>
                            {ADVANTAGES.map((a, i) => (
                                <FadeIn key={a.title} delay={i * 0.08}>
                                    <Stack
                                        direction="row"
                                        spacing={2.5}
                                        sx={{
                                            alignItems: 'flex-start',
                                            py: { xs: 2.5, md: 3 },
                                            borderTop: i === 0 ? 'none' : '1px solid',
                                            borderColor: 'divider',
                                        }}
                                    >
                                        <Box
                                            sx={(theme) => ({
                                                width: 48,
                                                height: 48,
                                                borderRadius: '14px',
                                                flexShrink: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: 'rgba(72, 190, 186, 0.16)',
                                                color: 'var(--joy-palette-primary-500)',
                                                [theme.getColorSchemeSelector('dark')]: { color: '#fff' },
                                            })}
                                        >
                                            <a.icon size={26} weight="fill" />
                                        </Box>
                                        <Box>
                                            <Typography level="title-md" sx={{ fontWeight: 700, mb: 0.5 }}>
                                                {a.title}
                                            </Typography>
                                            <Typography level="body-md" sx={{ color: 'text.secondary' }}>
                                                {a.text}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </FadeIn>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}
